import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import { LoginStepsContext } from "./LoginStepsContext";

export const LoginStepsProvider = ({ children, initialItems }) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [sharedData, setSharedData] = useState({});

  const currentValue = useMemo(
    () => ({
      items: initialItems,
      currentItemIndex,
      sharedData,
      onCurrentItemChange: setCurrentItemIndex,
      onSharedDataChange: setSharedData,
    }),
    [initialItems, currentItemIndex, sharedData]
  );

  return (
    <LoginStepsContext.Provider value={currentValue}>
      {children}
    </LoginStepsContext.Provider>
  );
};

LoginStepsProvider.propTypes = {
  children: PropTypes.node,
  initialItems: PropTypes.array,
};

export default LoginStepsProvider;
